import detailsSlideOutOpenerController from "./details-slide-out-opener-controller"

export default class extends detailsSlideOutOpenerController {
  static targets = ["headerContainer", "innerContent", "higherSlideOut", "template"]

  connect() {
    this.openSelf = this.openSelf.bind(this)
    this.openSelf()
    this.addEventListeners()
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "details-slide-out:close", this.closeAndRemove)
    App.Helpers.removeCustomEventListener(document, "details-slide-out:open", this.openHigherSlideOut)
  }

  openSelf() {
    this.setHeader()
    this.setContentTo(App.spinner())
    this.setFullWidth()
    if (this.hasContentHTML) {
      this.setContentTo(this.contentHTML)
    } else {
      App.Helpers.ajaxRequest({
        url: this.contentURL,
        successHandler: this.setContentTo.bind(this)
      })
    }
    setTimeout((() => this.element.classList.add("open")).bind(this), 10)
  }

  addEventListeners() {
    this.closeAndRemove = this.closeAndRemove.bind(this)
    App.Helpers.listenToCustomEvent(document, "details-slide-out:close", this.closeAndRemove)
    this.openHigherSlideOut = this.openHigherSlideOut.bind(this)
    App.Helpers.listenToCustomEvent(document, "details-slide-out:open", this.openHigherSlideOut)
  }

  setHeader() {
    const headerHTML = this.headerComponent
    const headerWithColor = headerHTML.replace(this.headerColorPlaceholder, this.headerColor)
    const headerWithTitle = headerWithColor.replace(this.titlePlaceholder, this.title)
    this.headerContainerTarget.innerHTML = headerWithTitle
  }

  setContentTo(content) {
    this.innerContentTarget.innerHTML = content
  }

  setFullWidth() {
    this.innerContentTarget.classList[this.isFullWidth ? "add" : "remove"]("slide-out-full")
  }

  closeAndRemove(event) {
    if (!this.higherSlideOutTarget.innerHTML) {
      this.element.classList.remove("open")
      setTimeout((() => {
        this.element.remove()
      }).bind(this), 200)
    }
  }

  openHigherSlideOut(event) {
    if (!this.higherSlideOutTarget.innerHTML) {
      App.Overlay.renderOverlay(this.element)
      this.setSlideOutDataAttrs(event.detail)
      this.higherSlideOutTarget.innerHTML = this.slideOutComponent.outerHTML
    }
  }

  get contentURL() {
    return this.data.get("content-url")
  }

  get headerComponent() {
    return this.data.get("header-component")
  }

  get headerColorPlaceholder() {
    return this.data.get("header-color-placeholder")
  }

  get headerColor() {
    return this.data.get("header-color")
  }

  get titlePlaceholder() {
    return this.data.get("title-placeholder")
  }

  get title() {
    return this.data.get("title")
  }

  get slideOutDataAttrsPrefix() {
    return this.identifier
  }

  get isFullWidth() {
    return App.Helpers.isTruthy(this.data.get("full-width"))
  }

  get templateHTML() {
    return this.data.get("slide-out-template")
  }

  get hasContentHTML() {
    return this.data.has("content-html") && this.contentHTML !== "null"
  }

  get contentHTML() {
    return this.data.get("content-html")
  }
}



// WEBPACK FOOTER //
// ./app/components/details/assets/javascript/details-slide-out-controller.js